<template>
  <li class="list-group-item">
    <div class="row d-flex">
      <div class="col">
        <div class="btn btn-sm float-start">
          <show-icon name="sticky_note_2" size="sm" class="align-middle"></show-icon>&nbsp;{{ t('models.note', 2) }}
        </div>
        <span class="badge bg-primary rounded-pill">{{nbNotes}}</span>
      </div>
      <div class="col">
        <button class="float-end btn btn-sm" @click="onNewNote">
          <show-icon name="new" size="sm" class="align-middle"></show-icon>
          <span class="d-none d-sm-inline">&nbsp;{{ $t('new') }}</span>
        </button>
      </div>
    </div>
    <div class="row" v-if="nbNotes > 0">
      <ul class="list-group list-group-flush">
        <li v-for="note in allNotes" :key="note.uuid" class="list-group-item">
          <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-10 text-start">
              <h5>{{ note.title }}</h5>
              <p>{{ note.details }}</p>
            </div>
            <div class="col-12-col-em-12 col-md-12 col-lg-2 text-end">
              <button class="btn btn-sm btn-outline-dark m-1" style="min-width: 5rem" @click="onEditNote(note.uuid)">
                <show-icon name="edit" size="sm" class="align-middle"></show-icon>
                <span class="d-none d-sm-inline">&nbsp;{{ $t('edit') }}</span>
              </button>
              <button class="btn btn-sm btn-danger m-1" style="min-width: 5rem" @click="onDeleteNote(note.uuid)">
                <show-icon name="delete" size="sm" class="align-middle"></show-icon>
                <span class="d-none d-sm-inline">&nbsp;{{ $t('delete') }}</span>
              </button>
            </div>
          </div>
        </li>
      </ul>
    </div>                  
    <NewNotePopup v-if="showNotePopup" 
                  :note-id="currentNoteUUID"
                  :site-id="siteId"
                  :owner-type="ownerType"
                  :owner-id="ownerId"
                  @closeNotePopup="onCloseNotePopup"
                  @noteUpdated="onNoteUpdated">
    </NewNotePopup>
  </li>  
</template>

<script>
import { useI18n } from 'vue-i18n'
import NewNotePopup from '@/views/notes/NewNotePopup.vue';

export default {
  name: "NoteListItem",
  setup() {
    const { t } = useI18n({ useScope: 'global' });
    return {
      t
    }  
  },
  props: [
    "siteId",
    "ownerType",
    "ownerId"
  ],
  data() {
    return {
      currentNoteUUID: null,
      showNewAssetPopup: false,
      showNewEmoPopup: false,
      showNotePopup: false
    }
  },
  computed: {
    nbNotes() {
      return this.allNotes.length;
    },
    allNotes() {
      return this.$store.getters.searchNotesBy({ site_id: this.siteId, owner_type: this.ownerType, owner_id: this.ownerId });
    }    
  },
  components: {
    NewNotePopup
  },
  methods: {
    onNewNote() {
      this.showNotePopup = true
    },
    onCloseNotePopup() {
      this.showNotePopup = false
    },
    onNoteUpdated(noteUUID) {
      console.log("Inside views/notes/Index.vue onNoteUpdated(): noteUUID ==> ", noteUUID);
      this.showNotePopup = false
    },
    onEditNote(noteUUID) {
      this.currentNoteUUID = noteUUID;
      this.showNotePopup = true
    },
    onDeleteNote(noteUUID) {
      console.log("Inside views/notes/Index.vue onDeleteNote(): noteUUID ==> ", noteUUID);
      if (confirm(this.$t('are_you_sure'))) {
        this.$store.dispatch("deleteNote", noteUUID);
      }
    }
  }
}
</script>